import React from 'react';

interface TabStateProps {
    setTabName: React.Dispatch<React.SetStateAction<string>>;
    tabId: string;
}

const TabState: React.FC<TabStateProps> = ({ setTabName, tabId, children }) => {
    React.useEffect(() => {
        setTabName(tabId);
    }, [setTabName, tabId]);

    return <>{children}</>;
};

export default TabState;
